module.exports = __webpack_public_path__ + "img/station_icon_grey.6289d249.svg";